(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[907],{

/***/ 30346:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/features",
      function () {
        return __webpack_require__(99940);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 99940:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ Prism; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Grid/index.js
var Grid = __webpack_require__(67478);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Link/index.js + 1 modules
var Link = __webpack_require__(25522);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Hero/index.js + 1 modules
var Hero = __webpack_require__(69591);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Hero/Description.js
var Description = __webpack_require__(50410);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Hero/Action.js
var Action = __webpack_require__(14593);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Hero/Grid.js
var Hero_Grid = __webpack_require__(36432);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Hero/ButtonLink.js
var ButtonLink = __webpack_require__(85765);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Hero/HeroBackground.js
var HeroBackground = __webpack_require__(30389);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Feature/Meta.js
var Meta = __webpack_require__(1041);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Feature/Image.js
var Image = __webpack_require__(66176);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Feature/index.js + 1 modules
var Feature = __webpack_require__(55185);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/r2/LandingElement/SimpleSection.js
var SimpleSection = __webpack_require__(93816);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/LandingElement/SimpleSectionStripped.js
var SimpleSectionStripped = __webpack_require__(37045);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Paragraph/index.js + 1 modules
var Paragraph = __webpack_require__(74229);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/UList/index.js + 1 modules
var UList = __webpack_require__(51192);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/r1/atoms/ContentContainer/index.js
var ContentContainer = __webpack_require__(12985);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/PageNavbar/index.js + 1 modules
var PageNavbar = __webpack_require__(11794);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/PageNavbar/Item.js
var Item = __webpack_require__(361);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/PageNavbar/Link.js
var PageNavbar_Link = __webpack_require__(24661);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/WhatIsNew/index.js + 1 modules
var WhatIsNew = __webpack_require__(8471);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/WhatIsNew/Image.js
var WhatIsNew_Image = __webpack_require__(37893);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/WhatIsNew/Content.js
var Content = __webpack_require__(2973);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Heading/index.js + 1 modules
var Heading = __webpack_require__(42866);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Icon/index.js + 1 modules
var Icon = __webpack_require__(61672);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Line/index.js + 1 modules
var Line = __webpack_require__(15945);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/smart-react/i18/index.js + 14 modules
var i18 = __webpack_require__(24155);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/smart-react/PageMeta/index.js
var PageMeta = __webpack_require__(93890);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Image/index.js + 1 modules
var atomic_react_Image = __webpack_require__(10334);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/smart-react/Html/index.js
var Html = __webpack_require__(73972);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/shared-utils/fn/pipe.js
var pipe = __webpack_require__(75833);
// EXTERNAL MODULE: ./src/SiteLayout/index.js + 4 modules
var SiteLayout = __webpack_require__(95309);
// EXTERNAL MODULE: ./src/services/index.js + 20 modules
var services = __webpack_require__(17104);
// EXTERNAL MODULE: ./src/SectionStart30DayTrial/index.js
var SectionStart30DayTrial = __webpack_require__(87666);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/AvailableOnOs/index.js + 1 modules
var AvailableOnOs = __webpack_require__(49614);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/AvailableOnOs/Icon.js
var AvailableOnOs_Icon = __webpack_require__(391);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/AvailableOnOs/Body.js
var Body = __webpack_require__(33517);
;// CONCATENATED MODULE: ./src/AvailableOnOs/index.js






const SectionTryForFree = ()=>{
    const [t] = (0,i18/* useLocale */.bU)("available-on-os");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(AvailableOnOs/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(AvailableOnOs_Icon/* default */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AvailableOnOs_Icon/* default.Icon */.Z.Icon, {
                        name: "mac"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AvailableOnOs_Icon/* default.Icon */.Z.Icon, {
                        name: "windows"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Body/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Body/* default.Item */.Z.Item, {
                    children: t("PRISM_IS")
                })
            })
        ]
    });
};
/* harmony default export */ var src_AvailableOnOs = (SectionTryForFree);

// EXTERNAL MODULE: ./src/AppError/withErrorHandling.js
var withErrorHandling = __webpack_require__(71802);
;// CONCATENATED MODULE: ./src/Apps/Prism/index.js





































const PrismAnova = ()=>{
    const [t] = (0,i18/* useLocale */.bU)("prism");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SiteLayout/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PageMeta/* default */.ZP, {
                title: t("META.TITLE"),
                description: t("META.DESCRIPTION"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PageMeta/* default.Canonical */.ZP.Canonical, {
                    href: "https://www.graphpad.com/features"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Hero/* default */.Z, {
                color: "gradient",
                align: "left",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Row */.X2, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Col */.JX, {
                            lg: 10,
                            lgOffset: 2,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* Row */.X2, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Col */.JX, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atomic_react_Image/* default */.Z, {
                                            src: "/images/graphpad/prism/logo-prism-white.svg",
                                            className: "ml-m32--lg h-16"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* Col */.JX, {
                                        lg: 8,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Description/* default */.Z, {
                                                sx: {
                                                    fontColor: "black--10"
                                                },
                                                spacing: {
                                                    mt: 5
                                                },
                                                children: t("HERO_DESCRIPTION")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Action/* default */.Z, {
                                                center: false,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Hero_Grid/* HeroRow */.P, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Hero_Grid/* HeroCol */.Z, {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonLink/* default */.Z, {
                                                                href: "/demos/",
                                                                isBlock: true,
                                                                children: t("START_A_FREE_TRIAL")
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Hero_Grid/* HeroCol */.Z, {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonLink/* default */.Z, {
                                                                href: "/how-to-buy/",
                                                                styleType: "info-light",
                                                                isOutline2: true,
                                                                isBlock: true,
                                                                children: t("PRICING")
                                                            })
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HeroBackground/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atomic_react_Image/* default */.Z, {
                            src: "/images/graphpad/prism/hero-bg.png"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PageNavbar/* default */.Z, {
                bgColor: "black--10",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Item/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(PageNavbar_Link/* default */.Z, {
                        href: "/updates",
                        children: [
                            t("DISCOVER"),
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                name: "angle-right",
                                spacing: {
                                    ml: 1
                                }
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SimpleSectionStripped/* default */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SimpleSection/* default.TitleV2 */.Z.TitleV2, {
                        spacing: {
                            mb: 20
                        },
                        children: t("COMPREHENSIVE_ANALYSIS")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(SimpleSection/* default.Body */.Z.Body, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Feature/* default */.Z, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Meta/* default */.Z, {
                                        md: 6,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Meta/* default.Title */.Z.Title, {
                                                children: t("ORGANIZE_YOUR_DATA")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Meta/* default.Description */.Z.Description, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* default */.Z, {
                                                    children: t("ORGANIZE_YOUR_DATA_DESC")
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Meta/* default.Action */.Z.Action, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                                    sx: {
                                                        fontSize: "m"
                                                    },
                                                    href: "/demos/",
                                                    children: t("START_A_FREE_TRIAL")
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                        src: "/images/graphpad/prism/prism-multi-variables-w1182-800.png",
                                        md: 6
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Feature/* default */.Z, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                        src: "/images/graphpad/prism/prism-t-test-w1076-800.png",
                                        md: 6
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Meta/* default */.Z, {
                                        md: 6,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Meta/* default.Title */.Z.Title, {
                                                children: t("PERFORM_THE_RIGHT_ANALYSIS")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Meta/* default.Description */.Z.Description, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* default */.Z, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Html/* default */.Z, {
                                                        Tag: "span",
                                                        children: t("PERFORM_THE_RIGHT_ANALYSIS_DESC", {
                                                            anovaLink: "/features/prism-anova",
                                                            nonlinearLink: "/features/prism-nonlinear-regression",
                                                            link: "/features/prism-survival-analysis"
                                                        })
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Meta/* default.Action */.Z.Action, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                                    sx: {
                                                        fontSize: "m"
                                                    },
                                                    href: "/demos/",
                                                    children: t("START_A_FREE_TRIAL")
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Feature/* default */.Z, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Meta/* default */.Z, {
                                        md: 6,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Meta/* default.Title */.Z.Title, {
                                                children: t("GET_ACTIONABLE_HELP")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Meta/* default.Description */.Z.Description, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* default */.Z, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Html/* default */.Z, {
                                                        Tag: "span",
                                                        children: t("GET_ACTIONABLE_HELP_DESC", {
                                                            link: "/prism-academy"
                                                        })
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Meta/* default.Action */.Z.Action, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                                    sx: {
                                                        fontSize: "m"
                                                    },
                                                    href: "/demos/",
                                                    children: t("START_A_FREE_TRIAL")
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                        src: "/images/graphpad/prism/prism-welcome-dialog-w1059-800.png",
                                        md: 6
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SimpleSectionStripped/* default */.Z, {
                isDark: true,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SimpleSection/* default.TitleV2 */.Z.TitleV2, {
                        spacing: {
                            mb: 20
                        },
                        children: t("WORK_SMARTER_NOT_HARDER")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(SimpleSection/* default.Body */.Z.Body, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Feature/* default */.Z, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                        src: "/images/graphpad/prism/prism-michaelis-w1102-800.png",
                                        md: 6
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Meta/* default */.Z, {
                                        md: 6,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Meta/* default.Title */.Z.Title, {
                                                children: t("ONE_CLICK_REGRESSION")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Meta/* default.Description */.Z.Description, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* default */.Z, {
                                                    children: t("ONE_CLICK_REGRESSION_DESC")
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Meta/* default.Action */.Z.Action, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                                    sx: {
                                                        fontSize: "m"
                                                    },
                                                    href: "/demos/",
                                                    children: t("START_A_FREE_TRIAL")
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Feature/* default */.Z, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Meta/* default */.Z, {
                                        md: 6,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Meta/* default.Title */.Z.Title, {
                                                children: t("FOCUS_ON_YOUR_RESEARCH")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Meta/* default.Description */.Z.Description, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* default */.Z, {
                                                    children: t("FOCUS_ON_YOUR_RESEARCH_DESC")
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Meta/* default.Action */.Z.Action, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                                    sx: {
                                                        fontSize: "m"
                                                    },
                                                    href: "/demos/",
                                                    children: t("START_A_FREE_TRIAL")
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                        src: "/images/graphpad/prism/prism-xy-w1224-800.png",
                                        md: 6
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Feature/* default */.Z, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                        src: "/images/graphpad/prism/prism-stars-on-graph-options-w1210-800.png",
                                        md: 6
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Meta/* default */.Z, {
                                        md: 6,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Meta/* default.Title */.Z.Title, {
                                                children: t("AUTOMATE_YOUR_WORK")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Meta/* default.Description */.Z.Description, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* default */.Z, {
                                                    children: t("AUTOMATE_YOUR_WORK_DESC")
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Meta/* default.Action */.Z.Action, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                                    sx: {
                                                        fontSize: "m"
                                                    },
                                                    href: "/demos/",
                                                    children: t("START_A_FREE_TRIAL")
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SimpleSectionStripped/* default */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SimpleSection/* default.TitleV2 */.Z.TitleV2, {
                        spacing: {
                            mb: 20
                        },
                        children: t("THE_FASTEST_WAY")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(SimpleSection/* default.Body */.Z.Body, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Feature/* default */.Z, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Meta/* default */.Z, {
                                        md: 6,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Meta/* default.Title */.Z.Title, {
                                                children: t("COUNTLESS_WAYS")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Meta/* default.Description */.Z.Description, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* default */.Z, {
                                                    children: t("COUNTLESS_WAYS_DESC")
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Meta/* default.Action */.Z.Action, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                                    sx: {
                                                        fontSize: "m"
                                                    },
                                                    href: "/demos/",
                                                    children: t("START_A_FREE_TRIAL")
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                        src: "/images/graphpad/prism/prism-customize-w1252-800.png",
                                        md: 6
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Feature/* default */.Z, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                        src: "/images/graphpad/prism/data-graph-inspector.png",
                                        md: 6
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Meta/* default */.Z, {
                                        md: 6,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Meta/* default.Title */.Z.Title, {
                                                children: t("EXPLORE_YOUR_DATA")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Meta/* default.Description */.Z.Description, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* default */.Z, {
                                                    children: t("EXPLORE_YOUR_DATA_DESC")
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Meta/* default.Action */.Z.Action, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                                    sx: {
                                                        fontSize: "m"
                                                    },
                                                    href: "/demos/",
                                                    children: t("START_A_FREE_TRIAL")
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Feature/* default */.Z, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Meta/* default */.Z, {
                                        md: 6,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Meta/* default.Title */.Z.Title, {
                                                children: t("EXPORT_PUBLICATION_QUALITY")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Meta/* default.Description */.Z.Description, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* default */.Z, {
                                                    children: t("EXPORT_PUBLICATION_QUALITY_DESC")
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Meta/* default.Action */.Z.Action, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                                    sx: {
                                                        fontSize: "m"
                                                    },
                                                    href: "/demos/",
                                                    children: t("START_A_FREE_TRIAL")
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                        src: "/images/graphpad/prism/prism-publication-w1178-800.png",
                                        md: 6
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Feature/* default */.Z, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                        src: "/images/graphpad/cloud/discuss-upd.png",
                                        md: 6
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Meta/* default */.Z, {
                                        md: 6,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Meta/* default.Title */.Z.Title, {
                                                children: t("ENHANCE_COLLABORATION")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Meta/* default.Description */.Z.Description, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* default */.Z, {
                                                    children: t("ENHANCE_COLLABORATION_DESC")
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Meta/* default.Action */.Z.Action, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                                    sx: {
                                                        fontSize: "m"
                                                    },
                                                    href: "/demos/",
                                                    children: t("START_A_FREE_TRIAL")
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SimpleSectionStripped/* default */.Z, {
                utility: {
                    bgColor: "5"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SimpleSection/* default.TitleV2 */.Z.TitleV2, {
                        sx: {
                            fontColor: "white"
                        },
                        spacing: {
                            mb: 5
                        },
                        children: t("DISCOVER_WHATS_NEW")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentContainer/* default */.Z, {
                        center: true,
                        lg: 8,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SimpleSection/* default.DescriptionV2 */.Z.DescriptionV2, {
                            sx: {
                                fontColor: "white"
                            },
                            children: t("INTRODUCING_AN_EVEN")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContentContainer/* default */.Z, {
                        center: true,
                        lg: 9,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Line/* default */.Z, {
                                isGradient: true,
                                spacing: {
                                    mb: 10
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                Tag: "h3",
                                sx: {
                                    fontSize: "l",
                                    fontColor: "white",
                                    textAlign: "center"
                                },
                                spacing: {
                                    my: 15
                                },
                                children: t("ENHANCED_DATA_VISUALIZATION")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(WhatIsNew/* default */.Z, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(WhatIsNew_Image/* default */.Z, {
                                        src: "/images/graphpad/prism/prism-bubble-w350-200.png"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Content/* default */.Z, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Content/* default.Title */.Z.Title, {
                                                children: t("BUBBLE_PLOTS")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Content/* default.Description */.Z.Description, {
                                                children: t("BUBBLE_PLOTS_DESC")
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(WhatIsNew/* default */.Z, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(WhatIsNew_Image/* default */.Z, {
                                        src: "/images/graphpad/prism/prism-violin-w350-200.png"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Content/* default */.Z, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Content/* default.Title */.Z.Title, {
                                                children: t("VIOLIN_PLOTS")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Content/* default.Description */.Z.Description, {
                                                children: t("VIOLIN_PLOTS_DESC")
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(WhatIsNew/* default */.Z, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(WhatIsNew_Image/* default */.Z, {
                                        src: "/images/graphpad/prism/prism-estimationplots-w350-200.png"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Content/* default */.Z, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Content/* default.Title */.Z.Title, {
                                                children: t("ESTIMATION_PLOTS")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Content/* default.Description */.Z.Description, {
                                                children: t("ESTIMATION_PLOTS_DESC")
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(WhatIsNew/* default */.Z, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(WhatIsNew_Image/* default */.Z, {
                                        src: "/images/graphpad/prism/prism-wn-smoothing-spline-w1281-200.png"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Content/* default */.Z, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Content/* default.Title */.Z.Title, {
                                                children: t("SMOOTHING_SPLINE")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Content/* default.Description */.Z.Description, {
                                                children: t("SMOOTHING_SPLINE_DESC")
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Row */.X2, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Col */.JX, {
                                    sx: {
                                        textAlign: "center"
                                    },
                                    spacing: {
                                        my: 10
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                        sx: {
                                            fontSize: "xl",
                                            fontWeight: "medium",
                                            fontColor: "4",
                                            hover: {
                                                fontColor: "white"
                                            }
                                        },
                                        href: "/guides/prism/latest/user-guide/whats-new-highlights.htm",
                                        children: t("READ_MORE")
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentContainer/* default */.Z, {
                        center: true,
                        lg: 9,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(SimpleSection/* default.Body */.Z.Body, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Line/* default */.Z, {
                                    isGradient: true,
                                    spacing: {
                                        mb: 10
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                    Tag: "h3",
                                    sx: {
                                        fontSize: "l",
                                        fontColor: "white",
                                        textAlign: "center"
                                    },
                                    spacing: {
                                        my: 15
                                    },
                                    children: t("IMPROVED_GRAPHING_AND_CUSTOMIZATION_OPTIONS")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(WhatIsNew/* default */.Z, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(WhatIsNew_Image/* default */.Z, {
                                            src: "/images/graphpad/prism/stars-on-graph.jpg"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Content/* default */.Z, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Content/* default.Title */.Z.Title, {
                                                    children: t("STARS_ON_GRAPH")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Content/* default.Description */.Z.Description, {
                                                    children: t("STARS_ON_GRAPH_DESC")
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(WhatIsNew/* default */.Z, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(WhatIsNew_Image/* default */.Z, {
                                            src: "/images/graphpad/prism/improved-graph-customization.png"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Content/* default */.Z, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Content/* default.Title */.Z.Title, {
                                                    children: t("IMPROVED_GRAPH_CUSTOMIZATION")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Content/* default.Description */.Z.Description, {
                                                    children: t("IMPROVED_GRAPH_CUSTOMIZATION_DESC")
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(WhatIsNew/* default */.Z, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(WhatIsNew_Image/* default */.Z, {
                                            src: "/images/graphpad/prism/prism-wn-automatically-label-bar-graphs-w1281-200.png"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Content/* default */.Z, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Content/* default.Title */.Z.Title, {
                                                    children: t("AUTOMATICALLY_LABEL_BAR_GRAPHS")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Content/* default.Description */.Z.Description, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Html/* default */.Z, {
                                                        Tag: "span",
                                                        children: t("AUTOMATICALLY_LABEL_BAR_GRAPHS_DESC")
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(WhatIsNew/* default */.Z, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(WhatIsNew_Image/* default */.Z, {
                                            src: "/images/graphpad/prism/prism-wn-improved-group-graphs-w960-200.png"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Content/* default */.Z, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Content/* default.Title */.Z.Title, {
                                                    children: t("IMPROVED_GROUPED_GRAPHS")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Content/* default.Description */.Z.Description, {
                                                    children: t("IMPROVED_GROUPED_GRAPHS_DESC")
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Row */.X2, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Col */.JX, {
                                        sx: {
                                            textAlign: "center"
                                        },
                                        spacing: {
                                            my: 10
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                            sx: {
                                                fontSize: "xl",
                                                fontWeight: "medium",
                                                fontColor: "4",
                                                hover: {
                                                    fontColor: "white"
                                                }
                                            },
                                            href: "/guides/prism/latest/user-guide/better-looking-graphs.htm",
                                            children: t("READ_MORE")
                                        })
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContentContainer/* default */.Z, {
                        center: true,
                        lg: 9,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Line/* default */.Z, {
                                isGradient: true,
                                spacing: {
                                    mb: 10
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Row */.X2, {
                                utility: {
                                    justify: "center"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* Col */.JX, {
                                    md: 10,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                            Tag: "h3",
                                            sx: {
                                                fontSize: "l",
                                                fontColor: "white",
                                                textAlign: "center"
                                            },
                                            children: t("MORE_INTUITIVE_NAVIGATION")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Row */.X2, {
                                            utility: {
                                                justify: "center"
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* Col */.JX, {
                                                lg: 10,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                                        Tag: "h3",
                                                        sx: {
                                                            fontSize: "m",
                                                            fontWeight: "medium",
                                                            fontColor: "white",
                                                            textAlign: "center"
                                                        },
                                                        spacing: {
                                                            mt: 10
                                                        },
                                                        children: t("GREATER_COLLABORATION")
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* default */.Z, {
                                                        sx: {
                                                            fontColor: "black--15",
                                                            textAlign: "center"
                                                        },
                                                        children: t("GREATER_COLLABORATION_DESC")
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Row */.X2, {
                                            utility: {
                                                justify: "center"
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* Col */.JX, {
                                                lg: 10,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                                        Tag: "h3",
                                                        sx: {
                                                            fontSize: "m",
                                                            fontWeight: "medium",
                                                            fontColor: "white",
                                                            textAlign: "center"
                                                        },
                                                        spacing: {
                                                            mt: 10
                                                        },
                                                        children: t("FAIR_DATA")
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* default */.Z, {
                                                        sx: {
                                                            fontColor: "black--15",
                                                            textAlign: "center"
                                                        },
                                                        children: t("FAIR_DATA_DESC")
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Row */.X2, {
                                            utility: {
                                                justify: "center"
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* Col */.JX, {
                                                lg: 10,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                                        Tag: "h3",
                                                        sx: {
                                                            fontSize: "m",
                                                            fontWeight: "medium",
                                                            fontColor: "white",
                                                            textAlign: "center"
                                                        },
                                                        spacing: {
                                                            mt: 10
                                                        },
                                                        children: t("EXPANDED_DATA")
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* default */.Z, {
                                                        sx: {
                                                            fontColor: "black--15",
                                                            textAlign: "center"
                                                        },
                                                        children: t("EXPANDED_DATA_DESC")
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Row */.X2, {
                                            utility: {
                                                justify: "center"
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* Col */.JX, {
                                                lg: 10,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                                        Tag: "h3",
                                                        sx: {
                                                            fontSize: "m",
                                                            fontWeight: "medium",
                                                            fontColor: "white",
                                                            textAlign: "center"
                                                        },
                                                        spacing: {
                                                            mt: 10
                                                        },
                                                        children: t("INTELLIGENT_DATA_WRANGLING")
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* default */.Z, {
                                                        sx: {
                                                            fontColor: "black--15",
                                                            textAlign: "center"
                                                        },
                                                        children: t("INTELLIGENT_DATA_WRANGLING_DESC")
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Row */.X2, {
                                            utility: {
                                                justify: "center"
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* Col */.JX, {
                                                lg: 10,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                                        Tag: "h3",
                                                        sx: {
                                                            fontSize: "m",
                                                            fontWeight: "medium",
                                                            fontColor: "white",
                                                            textAlign: "center"
                                                        },
                                                        spacing: {
                                                            mt: 10
                                                        },
                                                        children: t("HOOK_CONSTANT")
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* default */.Z, {
                                                        sx: {
                                                            fontColor: "black--15",
                                                            textAlign: "center"
                                                        },
                                                        children: t("HOOK_CONSTANT_DESC")
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Row */.X2, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Col */.JX, {
                                                sx: {
                                                    textAlign: "center"
                                                },
                                                spacing: {
                                                    my: 10
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                                    sx: {
                                                        fontSize: "xl",
                                                        fontWeight: "medium",
                                                        fontColor: "4",
                                                        hover: {
                                                            fontColor: "white"
                                                        }
                                                    },
                                                    href: "/updates/prism-1000-release-notes",
                                                    children: t("READ_MORE")
                                                })
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContentContainer/* default */.Z, {
                        center: true,
                        lg: 9,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Line/* default */.Z, {
                                isGradient: true,
                                spacing: {
                                    mb: 10
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Row */.X2, {
                                utility: {
                                    justify: "center"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* Col */.JX, {
                                    md: 10,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                            Tag: "h3",
                                            sx: {
                                                fontSize: "l",
                                                fontColor: "white",
                                                textAlign: "center"
                                            },
                                            children: t("NOW_FEATURING_EIGHT_KINDS_OF_DATA_TABLES")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Row */.X2, {
                                            utility: {
                                                justify: "center"
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* Col */.JX, {
                                                lg: 10,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                                        Tag: "h3",
                                                        sx: {
                                                            fontSize: "m",
                                                            fontWeight: "medium",
                                                            fontColor: "white",
                                                            textAlign: "center"
                                                        },
                                                        spacing: {
                                                            mt: 10
                                                        },
                                                        children: t("XY_TABLES")
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* default */.Z, {
                                                        sx: {
                                                            fontColor: "black--15",
                                                            textAlign: "center"
                                                        },
                                                        children: t("XY_TABLES_DESC")
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Row */.X2, {
                                            utility: {
                                                justify: "center"
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* Col */.JX, {
                                                lg: 10,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                                        Tag: "h3",
                                                        sx: {
                                                            fontSize: "m",
                                                            fontWeight: "medium",
                                                            fontColor: "white",
                                                            textAlign: "center"
                                                        },
                                                        spacing: {
                                                            mt: 10
                                                        },
                                                        children: t("COLUMN_TABLES")
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* default */.Z, {
                                                        sx: {
                                                            fontColor: "black--15",
                                                            textAlign: "center"
                                                        },
                                                        children: t("COLUMN_TABLES_DESC")
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Row */.X2, {
                                            utility: {
                                                justify: "center"
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* Col */.JX, {
                                                lg: 10,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                                        Tag: "h3",
                                                        sx: {
                                                            fontSize: "m",
                                                            fontWeight: "medium",
                                                            fontColor: "white",
                                                            textAlign: "center"
                                                        },
                                                        spacing: {
                                                            mt: 10
                                                        },
                                                        children: t("GROUPED_TABLES")
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* default */.Z, {
                                                        sx: {
                                                            fontColor: "black--15",
                                                            textAlign: "center"
                                                        },
                                                        children: t("GROUPED_TABLES_DESC")
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Row */.X2, {
                                            utility: {
                                                justify: "center"
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* Col */.JX, {
                                                lg: 10,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                                        Tag: "h3",
                                                        sx: {
                                                            fontSize: "m",
                                                            fontWeight: "medium",
                                                            fontColor: "white",
                                                            textAlign: "center"
                                                        },
                                                        spacing: {
                                                            mt: 10
                                                        },
                                                        children: t("CONTINGENCY_TABLES")
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* default */.Z, {
                                                        sx: {
                                                            fontColor: "black--15",
                                                            textAlign: "center"
                                                        },
                                                        children: t("CONTINGENCY_TABLES_DESC")
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Row */.X2, {
                                            utility: {
                                                justify: "center"
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* Col */.JX, {
                                                lg: 10,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                                        Tag: "h3",
                                                        sx: {
                                                            fontSize: "m",
                                                            fontWeight: "medium",
                                                            fontColor: "white",
                                                            textAlign: "center"
                                                        },
                                                        spacing: {
                                                            mt: 10
                                                        },
                                                        children: t("SURVIVAL_TABLES")
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* default */.Z, {
                                                        sx: {
                                                            fontColor: "black--15",
                                                            textAlign: "center"
                                                        },
                                                        children: t("SURVIVAL_TABLES_DESC")
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Row */.X2, {
                                            utility: {
                                                justify: "center"
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* Col */.JX, {
                                                lg: 10,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                                        Tag: "h3",
                                                        sx: {
                                                            fontSize: "m",
                                                            fontWeight: "medium",
                                                            fontColor: "white",
                                                            textAlign: "center"
                                                        },
                                                        spacing: {
                                                            mt: 10
                                                        },
                                                        children: t("PARTS_OF_WHOLE_TABLES")
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* default */.Z, {
                                                        sx: {
                                                            fontColor: "black--15",
                                                            textAlign: "center"
                                                        },
                                                        children: t("PARTS_OF_WHOLE_TABLES_DESC")
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Row */.X2, {
                                            utility: {
                                                justify: "center"
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* Col */.JX, {
                                                lg: 10,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                                        Tag: "h3",
                                                        sx: {
                                                            fontSize: "m",
                                                            fontWeight: "medium",
                                                            fontColor: "white",
                                                            textAlign: "center"
                                                        },
                                                        spacing: {
                                                            mt: 10
                                                        },
                                                        children: t("MULTIPLE_VARIABLES_TABLES")
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* default */.Z, {
                                                        sx: {
                                                            fontColor: "black--15",
                                                            textAlign: "center"
                                                        },
                                                        children: t("MULTIPLE_VARIABLES_TABLES_DESC")
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Row */.X2, {
                                            utility: {
                                                justify: "center"
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* Col */.JX, {
                                                lg: 10,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                                        Tag: "h3",
                                                        sx: {
                                                            fontSize: "m",
                                                            fontWeight: "medium",
                                                            fontColor: "white",
                                                            textAlign: "center"
                                                        },
                                                        spacing: {
                                                            mt: 10
                                                        },
                                                        children: t("NESTED_TABLES")
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* default */.Z, {
                                                        sx: {
                                                            fontColor: "black--15",
                                                            textAlign: "center"
                                                        },
                                                        children: t("NESTED_TABLES_DESC")
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Row */.X2, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Col */.JX, {
                                                sx: {
                                                    textAlign: "center"
                                                },
                                                spacing: {
                                                    my: 10
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                                    sx: {
                                                        fontSize: "xl",
                                                        fontWeight: "medium",
                                                        fontColor: "4",
                                                        hover: {
                                                            fontColor: "white"
                                                        }
                                                    },
                                                    href: "/guides/prism/latest/user-guide/using_data_table_format.htm",
                                                    children: t("READ_MORE")
                                                })
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContentContainer/* default */.Z, {
                        center: true,
                        lg: 9,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Line/* default */.Z, {
                                isGradient: true,
                                spacing: {
                                    mb: 10
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Row */.X2, {
                                utility: {
                                    justify: "center"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* Col */.JX, {
                                    md: 10,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                            Tag: "h3",
                                            sx: {
                                                fontSize: "l",
                                                fontColor: "white",
                                                textAlign: "center"
                                            },
                                            children: t("MORE_SOPHISTICATED_STATISTICAL_ANALYSES")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Row */.X2, {
                                            utility: {
                                                justify: "center"
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* Col */.JX, {
                                                lg: 10,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                                        Tag: "h3",
                                                        sx: {
                                                            fontSize: "m",
                                                            fontWeight: "medium",
                                                            fontColor: "white",
                                                            textAlign: "center"
                                                        },
                                                        spacing: {
                                                            mt: 10
                                                        },
                                                        children: t("PERFORM_REPEATED")
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* default */.Z, {
                                                        sx: {
                                                            fontColor: "black--15",
                                                            textAlign: "center"
                                                        },
                                                        children: t("PERFORM_REPEATED_DESC")
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Row */.X2, {
                                            utility: {
                                                justify: "center"
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* Col */.JX, {
                                                lg: 10,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                                        Tag: "h3",
                                                        sx: {
                                                            fontSize: "m",
                                                            fontWeight: "medium",
                                                            fontColor: "white",
                                                            textAlign: "center"
                                                        },
                                                        spacing: {
                                                            mt: 10
                                                        },
                                                        children: t("PERFORM_SIMPLE")
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* default */.Z, {
                                                        sx: {
                                                            fontColor: "black--15",
                                                            textAlign: "center"
                                                        },
                                                        children: t("PERFORM_SIMPLE_DESC")
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Row */.X2, {
                                            utility: {
                                                justify: "center"
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* Col */.JX, {
                                                lg: 10,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                                        Tag: "h3",
                                                        sx: {
                                                            fontSize: "m",
                                                            fontWeight: "medium",
                                                            fontColor: "white",
                                                            textAlign: "center"
                                                        },
                                                        spacing: {
                                                            mt: 10
                                                        },
                                                        children: t("PRINCIPAL_COMPONENT_ANALYSIS")
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* default */.Z, {
                                                        sx: {
                                                            fontColor: "black--15",
                                                            textAlign: "center"
                                                        },
                                                        children: t("PRINCIPAL_COMPONENT_ANALYSIS_DESC")
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Row */.X2, {
                                            utility: {
                                                justify: "center"
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* Col */.JX, {
                                                lg: 10,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                                        Tag: "h3",
                                                        sx: {
                                                            fontSize: "m",
                                                            fontWeight: "medium",
                                                            fontColor: "white",
                                                            textAlign: "center"
                                                        },
                                                        spacing: {
                                                            mt: 10
                                                        },
                                                        children: t("MULTIPLE_T_TEST")
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* default */.Z, {
                                                        sx: {
                                                            fontColor: "black--15",
                                                            textAlign: "center"
                                                        },
                                                        children: t("MULTIPLE_T_TEST_DESC")
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Row */.X2, {
                                            utility: {
                                                justify: "center"
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* Col */.JX, {
                                                lg: 10,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                                        Tag: "h3",
                                                        sx: {
                                                            fontSize: "m",
                                                            fontWeight: "medium",
                                                            fontColor: "white",
                                                            textAlign: "center"
                                                        },
                                                        spacing: {
                                                            mt: 10
                                                        },
                                                        children: t("ANALYZE_CATEGORICAL")
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* default */.Z, {
                                                        sx: {
                                                            fontColor: "black--15",
                                                            textAlign: "center"
                                                        },
                                                        children: t("ANALYZE_CATEGORICAL_DESC")
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Row */.X2, {
                                            utility: {
                                                justify: "center"
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* Col */.JX, {
                                                lg: 10,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                                        Tag: "h3",
                                                        sx: {
                                                            fontSize: "m",
                                                            fontWeight: "medium",
                                                            fontColor: "white",
                                                            textAlign: "center"
                                                        },
                                                        spacing: {
                                                            mt: 10
                                                        },
                                                        children: t("INTERPOLATION_FROM_MULTIPLE")
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* default */.Z, {
                                                        sx: {
                                                            fontColor: "black--15",
                                                            textAlign: "center"
                                                        },
                                                        children: t("INTERPOLATION_FROM_MULTIPLE_DESC")
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Row */.X2, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Col */.JX, {
                                                sx: {
                                                    textAlign: "center"
                                                },
                                                spacing: {
                                                    my: 10
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                                    sx: {
                                                        fontSize: "xl",
                                                        fontWeight: "medium",
                                                        fontColor: "4",
                                                        hover: {
                                                            fontColor: "white"
                                                        }
                                                    },
                                                    href: "/guides/prism/latest/user-guide/repeated-measures-anova-with-m.htm",
                                                    children: t("READ_MORE")
                                                })
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionStart30DayTrial/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SimpleSectionStripped/* default */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SimpleSection/* default.TitleV2 */.Z.TitleV2, {
                        spacing: {
                            mb: 20
                        },
                        children: t("DISCOVER_THE_BREADTH")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SimpleSection/* default.Body */.Z.Body, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* Row */.X2, {
                            mx: true,
                            utility: {
                                justify: "center"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* Col */.JX, {
                                    md: 6,
                                    spacing: {
                                        px: 4
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                            Tag: "h4",
                                            sx: {
                                                fontSize: "m"
                                            },
                                            spacing: {
                                                my: 3
                                            },
                                            children: t("STATISTICAL_COMPARISONS")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(UList/* default */.Z, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                    spacing: {
                                                        mb: 2,
                                                        ml: 2
                                                    },
                                                    children: t("STATISTICAL_COMPARISONS_ITEM_1")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                    spacing: {
                                                        mb: 2,
                                                        ml: 2
                                                    },
                                                    children: t("STATISTICAL_COMPARISONS_ITEM_2")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                    spacing: {
                                                        mb: 2,
                                                        ml: 2
                                                    },
                                                    children: t("STATISTICAL_COMPARISONS_ITEM_3")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                    spacing: {
                                                        mb: 2,
                                                        ml: 2
                                                    },
                                                    children: t("STATISTICAL_COMPARISONS_ITEM_4")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                    spacing: {
                                                        mb: 2,
                                                        ml: 2
                                                    },
                                                    children: t("STATISTICAL_COMPARISONS_ITEM_5")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                    spacing: {
                                                        mb: 2,
                                                        ml: 2
                                                    },
                                                    children: t("STATISTICAL_COMPARISONS_ITEM_6")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                    spacing: {
                                                        mb: 2,
                                                        ml: 2
                                                    },
                                                    children: t("STATISTICAL_COMPARISONS_ITEM_7")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                    spacing: {
                                                        mb: 2,
                                                        ml: 2
                                                    },
                                                    children: t("STATISTICAL_COMPARISONS_ITEM_8")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                    spacing: {
                                                        mb: 2,
                                                        ml: 2
                                                    },
                                                    children: t("STATISTICAL_COMPARISONS_ITEM_9")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                    spacing: {
                                                        mb: 2,
                                                        ml: 2
                                                    },
                                                    children: t("STATISTICAL_COMPARISONS_ITEM_10")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                    spacing: {
                                                        mb: 2,
                                                        ml: 2
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Html/* default */.Z, {
                                                        Tag: "span",
                                                        children: t("STATISTICAL_COMPARISONS_ITEM_11")
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                    spacing: {
                                                        mb: 2,
                                                        ml: 2
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Html/* default */.Z, {
                                                        Tag: "span",
                                                        children: t("STATISTICAL_COMPARISONS_ITEM_12")
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                    spacing: {
                                                        mb: 2,
                                                        ml: 2
                                                    },
                                                    children: t("STATISTICAL_COMPARISONS_ITEM_13")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                    spacing: {
                                                        mb: 2,
                                                        ml: 2
                                                    },
                                                    children: t("STATISTICAL_COMPARISONS_ITEM_14")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                    spacing: {
                                                        mb: 2,
                                                        ml: 2
                                                    },
                                                    children: t("STATISTICAL_COMPARISONS_ITEM_15")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                    spacing: {
                                                        mb: 2,
                                                        ml: 2
                                                    },
                                                    children: t("STATISTICAL_COMPARISONS_ITEM_16")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                    spacing: {
                                                        mb: 2,
                                                        ml: 2
                                                    },
                                                    children: t("STATISTICAL_COMPARISONS_ITEM_17")
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                            Tag: "h4",
                                            sx: {
                                                fontSize: "m"
                                            },
                                            spacing: {
                                                my: 3
                                            },
                                            children: t("NONLINEAR_REGRESSION")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(UList/* default */.Z, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                    spacing: {
                                                        mb: 2,
                                                        ml: 2
                                                    },
                                                    children: t("NONLINEAR_REGRESSION_ITEM_1")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                    spacing: {
                                                        mb: 2,
                                                        ml: 2
                                                    },
                                                    children: t("NONLINEAR_REGRESSION_ITEM_2")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                    spacing: {
                                                        mb: 2,
                                                        ml: 2
                                                    },
                                                    children: t("NONLINEAR_REGRESSION_ITEM_3")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                    spacing: {
                                                        mb: 2,
                                                        ml: 2
                                                    },
                                                    children: t("NONLINEAR_REGRESSION_ITEM_4")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                    spacing: {
                                                        mb: 2,
                                                        ml: 2
                                                    },
                                                    children: t("NONLINEAR_REGRESSION_ITEM_5")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                    spacing: {
                                                        mb: 2,
                                                        ml: 2
                                                    },
                                                    children: t("NONLINEAR_REGRESSION_ITEM_6")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                    spacing: {
                                                        mb: 2,
                                                        ml: 2
                                                    },
                                                    children: t("NONLINEAR_REGRESSION_ITEM_7")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                    spacing: {
                                                        mb: 2,
                                                        ml: 2
                                                    },
                                                    children: t("NONLINEAR_REGRESSION_ITEM_8")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                    spacing: {
                                                        mb: 2,
                                                        ml: 2
                                                    },
                                                    children: t("NONLINEAR_REGRESSION_ITEM_9")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                    spacing: {
                                                        mb: 2,
                                                        ml: 2
                                                    },
                                                    children: t("NONLINEAR_REGRESSION_ITEM_10")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                    spacing: {
                                                        mb: 2,
                                                        ml: 2
                                                    },
                                                    children: t("NONLINEAR_REGRESSION_ITEM_11")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                    spacing: {
                                                        mb: 2,
                                                        ml: 2
                                                    },
                                                    children: t("NONLINEAR_REGRESSION_ITEM_12")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                    spacing: {
                                                        mb: 2,
                                                        ml: 2
                                                    },
                                                    children: t("NONLINEAR_REGRESSION_ITEM_13")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                    spacing: {
                                                        mb: 2,
                                                        ml: 2
                                                    },
                                                    children: t("NONLINEAR_REGRESSION_ITEM_14")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                    spacing: {
                                                        mb: 2,
                                                        ml: 2
                                                    },
                                                    children: t("NONLINEAR_REGRESSION_ITEM_15")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                    spacing: {
                                                        mb: 2,
                                                        ml: 2
                                                    },
                                                    children: t("NONLINEAR_REGRESSION_ITEM_16")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                    spacing: {
                                                        mb: 2,
                                                        ml: 2
                                                    },
                                                    children: t("NONLINEAR_REGRESSION_ITEM_17")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                    spacing: {
                                                        mb: 2,
                                                        ml: 2
                                                    },
                                                    children: t("NONLINEAR_REGRESSION_ITEM_18")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                    spacing: {
                                                        mb: 2,
                                                        ml: 2
                                                    },
                                                    children: t("NONLINEAR_REGRESSION_ITEM_19")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                    spacing: {
                                                        mb: 2,
                                                        ml: 2
                                                    },
                                                    children: t("NONLINEAR_REGRESSION_ITEM_20")
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                            Tag: "h4",
                                            sx: {
                                                fontSize: "m"
                                            },
                                            spacing: {
                                                my: 3
                                            },
                                            children: t("SURVIVAL_ANALYSIS")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(UList/* default */.Z, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                    spacing: {
                                                        mb: 2,
                                                        ml: 2
                                                    },
                                                    children: t("SURVIVAL_ANALYSIS_ITEM_1")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                    spacing: {
                                                        mb: 2,
                                                        ml: 2
                                                    },
                                                    children: t("SURVIVAL_ANALYSIS_ITEM_2")
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* Col */.JX, {
                                    md: 6,
                                    spacing: {
                                        px: 4
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                            Tag: "h4",
                                            sx: {
                                                fontSize: "m"
                                            },
                                            spacing: {
                                                my: 3
                                            },
                                            children: t("PRINCIPAL_COMPONENT_ANALYSIS_TITLE")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(UList/* default */.Z, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                    spacing: {
                                                        mb: 2,
                                                        ml: 2
                                                    },
                                                    children: t("PRINCIPAL_COMPONENT_ANALYSIS_ITEM_1")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                    spacing: {
                                                        mb: 2,
                                                        ml: 2
                                                    },
                                                    children: t("PRINCIPAL_COMPONENT_ANALYSIS_ITEM_2")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                    spacing: {
                                                        mb: 2,
                                                        ml: 2
                                                    },
                                                    children: t("PRINCIPAL_COMPONENT_ANALYSIS_ITEM_3")
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                            Tag: "h4",
                                            sx: {
                                                fontSize: "m"
                                            },
                                            spacing: {
                                                my: 3
                                            },
                                            children: t("MULTIPLE_VARIABLE_GRAPHING")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(UList/* default */.Z, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                    spacing: {
                                                        mb: 2,
                                                        ml: 2
                                                    },
                                                    children: t("MULTIPLE_VARIABLE_GRAPHING_ITEM_1")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                    spacing: {
                                                        mb: 2,
                                                        ml: 2
                                                    },
                                                    children: t("MULTIPLE_VARIABLE_GRAPHING_ITEM_2")
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                            Tag: "h4",
                                            sx: {
                                                fontSize: "m"
                                            },
                                            spacing: {
                                                my: 3
                                            },
                                            children: t("COLUMN_STATISTICS")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(UList/* default */.Z, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                    spacing: {
                                                        mb: 2,
                                                        ml: 2
                                                    },
                                                    children: t("COLUMN_STATISTICS_ITEM_1")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                    spacing: {
                                                        mb: 2,
                                                        ml: 2
                                                    },
                                                    children: t("COLUMN_STATISTICS_ITEM_2")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                    spacing: {
                                                        mb: 2,
                                                        ml: 2
                                                    },
                                                    children: t("COLUMN_STATISTICS_ITEM_3")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                    spacing: {
                                                        mb: 2,
                                                        ml: 2
                                                    },
                                                    children: t("COLUMN_STATISTICS_ITEM_4")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                    spacing: {
                                                        mb: 2,
                                                        ml: 2
                                                    },
                                                    children: t("COLUMN_STATISTICS_ITEM_5")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                    spacing: {
                                                        mb: 2,
                                                        ml: 2
                                                    },
                                                    children: t("COLUMN_STATISTICS_ITEM_6")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                    spacing: {
                                                        mb: 2,
                                                        ml: 2
                                                    },
                                                    children: t("COLUMN_STATISTICS_ITEM_7")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                    spacing: {
                                                        mb: 2,
                                                        ml: 2
                                                    },
                                                    children: t("COLUMN_STATISTICS_ITEM_8")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                    spacing: {
                                                        mb: 2,
                                                        ml: 2
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Html/* default */.Z, {
                                                        Tag: "span",
                                                        children: t("COLUMN_STATISTICS_ITEM_9")
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                            Tag: "h4",
                                            sx: {
                                                fontSize: "m"
                                            },
                                            spacing: {
                                                my: 3
                                            },
                                            children: t("SIMPLE_LINEAR")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(UList/* default */.Z, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                    spacing: {
                                                        mb: 2,
                                                        ml: 2
                                                    },
                                                    children: t("SIMPLE_LINEAR_ITEM_1")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                    spacing: {
                                                        mb: 2,
                                                        ml: 2
                                                    },
                                                    children: t("SIMPLE_LINEAR_ITEM_2")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                    spacing: {
                                                        mb: 2,
                                                        ml: 2
                                                    },
                                                    children: t("SIMPLE_LINEAR_ITEM_3")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                    spacing: {
                                                        mb: 2,
                                                        ml: 2
                                                    },
                                                    children: t("SIMPLE_LINEAR_ITEM_4")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                    spacing: {
                                                        mb: 2,
                                                        ml: 2
                                                    },
                                                    children: t("SIMPLE_LINEAR_ITEM_5")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                    spacing: {
                                                        mb: 2,
                                                        ml: 2
                                                    },
                                                    children: t("SIMPLE_LINEAR_ITEM_6")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                    spacing: {
                                                        mb: 2,
                                                        ml: 2
                                                    },
                                                    children: t("SIMPLE_LINEAR_ITEM_7")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                    spacing: {
                                                        mb: 2,
                                                        ml: 2
                                                    },
                                                    children: t("SIMPLE_LINEAR_ITEM_8")
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                            Tag: "h4",
                                            sx: {
                                                fontSize: "m"
                                            },
                                            spacing: {
                                                my: 3
                                            },
                                            children: t("GENERALIZED_LINEAR_MODELS")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(UList/* default */.Z, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                    spacing: {
                                                        mb: 2,
                                                        ml: 2
                                                    },
                                                    children: t("GENERALIZED_LINEAR_MODELS_ITEM_1")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                    spacing: {
                                                        mb: 2,
                                                        ml: 2
                                                    },
                                                    children: t("GENERALIZED_LINEAR_MODELS_ITEM_2")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                    spacing: {
                                                        mb: 2,
                                                        ml: 2
                                                    },
                                                    children: t("GENERALIZED_LINEAR_MODELS_ITEM_3")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                    spacing: {
                                                        mb: 2,
                                                        ml: 2
                                                    },
                                                    children: t("GENERALIZED_LINEAR_MODELS_ITEM_4")
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                            Tag: "h4",
                                            sx: {
                                                fontSize: "m"
                                            },
                                            spacing: {
                                                my: 3
                                            },
                                            children: t("CLINICAL_LAB_STATISTICS")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(UList/* default */.Z, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                    spacing: {
                                                        mb: 2,
                                                        ml: 2
                                                    },
                                                    children: t("CLINICAL_LAB_STATISTICS_ITEM_1")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                    spacing: {
                                                        mb: 2,
                                                        ml: 2
                                                    },
                                                    children: t("CLINICAL_LAB_STATISTICS_ITEM_2")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                    spacing: {
                                                        mb: 2,
                                                        ml: 2
                                                    },
                                                    children: t("CLINICAL_LAB_STATISTICS_ITEM_3")
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                            Tag: "h4",
                                            sx: {
                                                fontSize: "m"
                                            },
                                            spacing: {
                                                my: 3
                                            },
                                            children: t("SIMULATIONS")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(UList/* default */.Z, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                    spacing: {
                                                        mb: 2,
                                                        ml: 2
                                                    },
                                                    children: t("SIMULATIONS_ITEM_1")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                    spacing: {
                                                        mb: 2,
                                                        ml: 2
                                                    },
                                                    children: t("SIMULATIONS_ITEM_2")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                    spacing: {
                                                        mb: 2,
                                                        ml: 2
                                                    },
                                                    children: t("SIMULATIONS_ITEM_3")
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                            Tag: "h4",
                                            sx: {
                                                fontSize: "m"
                                            },
                                            spacing: {
                                                my: 3
                                            },
                                            children: t("OTHER_CALCULATIONS")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(UList/* default */.Z, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                    spacing: {
                                                        mb: 2,
                                                        ml: 2
                                                    },
                                                    children: t("OTHER_CALCULATIONS_ITEM_1")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                    spacing: {
                                                        mb: 2,
                                                        ml: 2
                                                    },
                                                    children: t("OTHER_CALCULATIONS_ITEM_2")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                    spacing: {
                                                        mb: 2,
                                                        ml: 2
                                                    },
                                                    children: t("OTHER_CALCULATIONS_ITEM_3")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                    spacing: {
                                                        mb: 2,
                                                        ml: 2
                                                    },
                                                    children: t("OTHER_CALCULATIONS_ITEM_4")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                    spacing: {
                                                        mb: 2,
                                                        ml: 2
                                                    },
                                                    children: t("OTHER_CALCULATIONS_ITEM_5")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                    spacing: {
                                                        mb: 2,
                                                        ml: 2
                                                    },
                                                    children: t("OTHER_CALCULATIONS_ITEM_6")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                    spacing: {
                                                        mb: 2,
                                                        ml: 2
                                                    },
                                                    children: t("OTHER_CALCULATIONS_ITEM_7")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                    spacing: {
                                                        mb: 2,
                                                        ml: 2
                                                    },
                                                    children: t("OTHER_CALCULATIONS_ITEM_8")
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(src_AvailableOnOs, {})
        ]
    });
};
/* harmony default export */ var Prism = ((0,pipe/* default */.Z)(PrismAnova, withErrorHandling/* default */.Z, services/* default */.ZP));

;// CONCATENATED MODULE: ./pages/features/index.js



/***/ }),

/***/ 38100:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ AppError_AppError; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/smart-react/ApplicationError/index.js
var ApplicationError = __webpack_require__(66651);
// EXTERNAL MODULE: ./src/AppError/error-prop-type.js
var error_prop_type = __webpack_require__(76965);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Heading/index.js + 1 modules
var Heading = __webpack_require__(42866);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Paragraph/index.js + 1 modules
var Paragraph = __webpack_require__(74229);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Link/index.js + 1 modules
var Link = __webpack_require__(25522);
// EXTERNAL MODULE: ./src/routes.js
var routes = __webpack_require__(30233);
;// CONCATENATED MODULE: ./src/AppError/Error400.js






const Error400 = ()=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                Tag: "h1",
                sx: {
                    fontSize: "xl",
                    fontColor: "3",
                    textAlign: "center"
                },
                spacing: {
                    mb: 6
                },
                children: "Bad Request"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Paragraph/* default */.Z, {
                sx: {
                    fontSize: "s",
                    textAlign: "center"
                },
                children: [
                    "We’re sorry, you didn’t provide all mandatory inputs or provided data was incorrect.",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    "Please",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                        sx: {
                            fontSize: "s"
                        },
                        href: routes/* default.external.contactUs */.Z.external.contactUs,
                        children: "contact us"
                    }),
                    " ",
                    "for further assistance."
                ]
            })
        ]
    });
/* harmony default export */ var AppError_Error400 = (Error400);

// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./src/AppError/Error401.js







const Error401 = ()=>{
    const { asPath  } = (0,router.useRouter)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                Tag: "h1",
                sx: {
                    fontSize: "xl",
                    fontColor: "3",
                    textAlign: "center"
                },
                spacing: {
                    mb: 6
                },
                children: "Not Authorized"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Paragraph/* default */.Z, {
                sx: {
                    fontSize: "s",
                    textAlign: "center"
                },
                children: [
                    "We’re sorry. You are not authorized to access the requested resource.",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    "Please",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                        sx: {
                            fontSize: "s"
                        },
                        href: "".concat(routes/* default.auth.logout */.Z.auth.logout, "?returnUrl=").concat(encodeURIComponent(asPath)),
                        children: "sign in"
                    }),
                    " ",
                    "with a different account, or",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                        sx: {
                            fontSize: "s"
                        },
                        href: routes/* default.external.contactUs */.Z.external.contactUs,
                        children: "contact us"
                    }),
                    " ",
                    "for further assistance."
                ]
            })
        ]
    });
};
/* harmony default export */ var AppError_Error401 = (Error401);

;// CONCATENATED MODULE: ./src/AppError/Error403.js






const Error403 = ()=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                Tag: "h1",
                sx: {
                    fontSize: "xl",
                    fontColor: "3",
                    textAlign: "center"
                },
                spacing: {
                    mb: 6
                },
                children: "Not Permitted"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Paragraph/* default */.Z, {
                sx: {
                    fontSize: "s",
                    textAlign: "center"
                },
                children: [
                    "We’re sorry, you don’t have sufficient permissions to access this resource.",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    "Please",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                        sx: {
                            fontSize: "s"
                        },
                        href: routes/* default.external.contactUs */.Z.external.contactUs,
                        children: "contact us"
                    }),
                    " ",
                    "for further assistance."
                ]
            })
        ]
    });
/* harmony default export */ var AppError_Error403 = (Error403);

// EXTERNAL MODULE: ./node_modules/@insightfulscience/smart-react/PageTitle/index.js
var PageTitle = __webpack_require__(73446);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/smart-react/i18/index.js + 14 modules
var i18 = __webpack_require__(24155);
;// CONCATENATED MODULE: ./src/AppError/Error404.js






const Error404 = ()=>{
    const [t] = (0,i18/* useLocale */.bU)("app-error");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PageTitle/* default */.Z, {
                title: t("404.META_TITLE")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                Tag: "h1",
                sx: {
                    fontSize: "xl",
                    fontColor: "3",
                    textAlign: "center"
                },
                spacing: {
                    mb: 6
                },
                children: t("404.TITLE")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* default */.Z, {
                sx: {
                    fontSize: "s",
                    textAlign: "center"
                },
                children: t("404.DESCRIPTION")
            })
        ]
    });
};
/* harmony default export */ var AppError_Error404 = (Error404);

;// CONCATENATED MODULE: ./src/AppError/Error500.js






const Error500 = ()=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                Tag: "h1",
                sx: {
                    fontSize: "xl",
                    fontColor: "3",
                    textAlign: "center"
                },
                spacing: {
                    mb: 6
                },
                children: "Something went wrong"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Paragraph/* default */.Z, {
                sx: {
                    fontSize: "s",
                    textAlign: "center"
                },
                children: [
                    "We’re sorry. Something has gone wrong with the application.",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    "Please try again later or",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                        sx: {
                            fontSize: "s"
                        },
                        href: routes/* default.external.contactUs */.Z.external.contactUs,
                        children: "contact us"
                    }),
                    " ",
                    "for further assistance."
                ]
            })
        ]
    });
/* harmony default export */ var AppError_Error500 = (Error500);

;// CONCATENATED MODULE: ./src/AppError/Error503.js




const Error503 = ()=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                Tag: "h1",
                sx: {
                    fontSize: "xl",
                    fontColor: "3",
                    textAlign: "center"
                },
                spacing: {
                    mb: 6
                },
                children: "Service Unavailable"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* default */.Z, {
                sx: {
                    fontSize: "s",
                    textAlign: "center"
                },
                children: "We’re sorry. We’re temporarily unavailable."
            })
        ]
    });
/* harmony default export */ var AppError_Error503 = (Error503);

// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/r1/atoms/ContentContainer/index.js
var ContentContainer = __webpack_require__(12985);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Block/index.js + 1 modules
var Block = __webpack_require__(6949);
;// CONCATENATED MODULE: ./src/AppError/ErrorDetails.js





const ErrorDetails = (param)=>/*#__PURE__*/ {
    let { error  } = param;
    return (0,jsx_runtime.jsx)(ContentContainer/* default */.Z, {
        mx: true,
        md: 10,
        lg: 8,
        center: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Block/* default */.Z, {
            utility: {
                bgColor: "black"
            },
            className: "panel",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("pre", {
                className: " text-color-white px-5 py-5",
                children: JSON.stringify(error, null, 2)
            })
        })
    });
};
ErrorDetails.propTypes = {
    error: error_prop_type/* default */.Z
};
/* harmony default export */ var AppError_ErrorDetails = ( false ? 0 : ()=>null);

// EXTERNAL MODULE: ./src/AppError/ErrorLayout.js
var ErrorLayout = __webpack_require__(59093);
// EXTERNAL MODULE: ./src/sentry.js + 79 modules
var sentry = __webpack_require__(77264);
;// CONCATENATED MODULE: ./src/AppError/AppError.js














const errorComponents = {
    400: AppError_Error400,
    401: AppError_Error401,
    403: AppError_Error403,
    404: AppError_Error404,
    503: AppError_Error503
};
const AppError = (param)=>{
    let { error , Layout =ErrorLayout/* default */.Z , ...props } = param;
    const { code  } = error;
    const ErrorComponent = errorComponents[code] || AppError_Error500;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout, {
        extra: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppError_ErrorDetails, {
            error: error
        }),
        ...props,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorComponent, {
            error: error
        })
    });
};
AppError.getInitialProps = (context)=>{
    const { err , res  } = context;
    const error = ApplicationError/* default.of */.Z.of(err !== null && err !== void 0 ? err : {});
    if (res) {
        res.statusCode = error.code;
    }
    (0,sentry/* notifySentry */.Yw)(err, context);
    if (error.code >= 500 && error.code !== 503 && error.originalError != null) throw error.originalError;
    return {
        error: error.toSerializable()
    };
};
AppError.propTypes = {
    error: error_prop_type/* default */.Z,
    Layout: prop_types.elementType
};
/* harmony default export */ var AppError_AppError = (AppError);


/***/ }),

/***/ 59093:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _insightfulscience_atomic_react_SimpleTemplate__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87385);
/* harmony import */ var _insightfulscience_atomic_react_Section__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(93512);
/* harmony import */ var _SiteLayout__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(95309);






/** @type {React.FC<{ children: React.ReactNode, extra: React.ReactNode }>} */ const ErrorLayout = (param)=>/*#__PURE__*/ {
    let { children , extra  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_SiteLayout__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_SimpleTemplate__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                children: children
            }),
            extra && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Section__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                spacing: {
                    pt: 9,
                    pb: 18,
                    md: {
                        pt: 9,
                        pb: 18
                    }
                },
                children: extra
            })
        ]
    });
};
ErrorLayout.propTypes = {
    children: prop_types__WEBPACK_IMPORTED_MODULE_5__.node,
    extra: prop_types__WEBPACK_IMPORTED_MODULE_5__.node
};
/** @type {React.FC<{ children: React.ReactNode, extra: React.ReactNode, isAuthorized: boolean }>} */ const ErrorLayoutPure = (param)=>/*#__PURE__*/ {
    let { children , extra , isAuthorized  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_SiteLayout__WEBPACK_IMPORTED_MODULE_4__/* ["default"].Pure */ .Z.Pure, {
        isAuthorized: isAuthorized,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_SimpleTemplate__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                children: children
            }),
            extra && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Section__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                spacing: {
                    pt: 9,
                    pb: 18,
                    md: {
                        pt: 9,
                        pb: 18
                    }
                },
                children: extra
            })
        ]
    });
};
ErrorLayoutPure.propTypes = {
    ...ErrorLayout.propTypes,
    isAuthorized: prop_types__WEBPACK_IMPORTED_MODULE_5__.bool
};
ErrorLayout.Pure = ErrorLayoutPure;
/* harmony default export */ __webpack_exports__["Z"] = (ErrorLayout);


/***/ }),

/***/ 76965:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_0__);

/* harmony default export */ __webpack_exports__["Z"] = ((0,prop_types__WEBPACK_IMPORTED_MODULE_0__.shape)({
    code: prop_types__WEBPACK_IMPORTED_MODULE_0__.number,
    message: prop_types__WEBPACK_IMPORTED_MODULE_0__.string,
    stack: (0,prop_types__WEBPACK_IMPORTED_MODULE_0__.arrayOf)(prop_types__WEBPACK_IMPORTED_MODULE_0__.string),
    originalError: (0,prop_types__WEBPACK_IMPORTED_MODULE_0__.shape)({
        name: prop_types__WEBPACK_IMPORTED_MODULE_0__.string,
        code: prop_types__WEBPACK_IMPORTED_MODULE_0__.number,
        message: prop_types__WEBPACK_IMPORTED_MODULE_0__.string
    })
}));


/***/ }),

/***/ 71802:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _insightfulscience_shared_utils_fn__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(10455);
/* harmony import */ var _AppError__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(38100);




const withErrorHandling = (Component)=>{
    const WithErrorHandling = (param)=>{
        let { error , ...props } = param;
        if (error == null) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Component, {
                ...props
            });
        }
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_AppError__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            error: error
        });
    };
    Object.assign(WithErrorHandling, Component);
    WithErrorHandling.propTypes = _AppError__WEBPACK_IMPORTED_MODULE_2__/* ["default"].propTypes */ .Z.propTypes;
    WithErrorHandling.getInitialProps = (context, container)=>{
        try {
            const props = Component.getInitialProps ? Component.getInitialProps(context, container) : {};
            return (0,_insightfulscience_shared_utils_fn__WEBPACK_IMPORTED_MODULE_3__/* .isPromise */ .tI)(props) ? props.catch((err)=>{
                return _AppError__WEBPACK_IMPORTED_MODULE_2__/* ["default"].getInitialProps */ .Z.getInitialProps({
                    ...context,
                    err
                }, container);
            }) : props;
        } catch (err) {
            return _AppError__WEBPACK_IMPORTED_MODULE_2__/* ["default"].getInitialProps */ .Z.getInitialProps({
                ...context,
                err
            }, container);
        }
    };
    return WithErrorHandling;
};
/* harmony default export */ __webpack_exports__["Z"] = (withErrorHandling);


/***/ }),

/***/ 87666:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _insightfulscience_smart_react_i18__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(24155);
/* harmony import */ var _insightfulscience_atomic_react_SectionStart30DayTrial__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(51204);




const SectionInvolveYourTeam = ()=>{
    const [t] = (0,_insightfulscience_smart_react_i18__WEBPACK_IMPORTED_MODULE_2__/* .useLocale */ .bU)("section-start-free-30-day-trial");
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_insightfulscience_atomic_react_SectionStart30DayTrial__WEBPACK_IMPORTED_MODULE_3__/* .SectionStart30DayTrial */ .Oe, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_SectionStart30DayTrial__WEBPACK_IMPORTED_MODULE_3__/* .SectionStart30DayTrialButton */ .kc, {
                href: "/demos/",
                children: t("BUTTON_TEXT")
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_SectionStart30DayTrial__WEBPACK_IMPORTED_MODULE_3__/* .SectionStart30DayTrialText */ .gj, {
                children: t("SUB_TEXT")
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SectionInvolveYourTeam);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1888,6445,9975,5309,9774,2888,179], function() { return __webpack_exec__(97239), __webpack_exec__(30346); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);